import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetAsepticProcessLogDetailByRunIdQuery } from 'api';
import { useMachine } from 'hooks';
import { ReactNode } from 'react';

export const useProcessLogDetailRunIdWidget = (runlogId: string): {
  isLoading?: boolean;
  hasError?: ReactNode;
  processData?: Record<string, unknown>;
  machineId: string | undefined;
} => {
  const { id } = useMachine()?.machine || {};

  const { data, isFetching, error } = useGetAsepticProcessLogDetailByRunIdQuery(
    runlogId && id 
      ? { machineId: id as string, runlogId}
      : skipToken 
  );
  return {
    isLoading: isFetching,
    hasError: error ? true : false,
    processData: data,
    machineId:id
  };
};
